import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import DomainChecker from './components/DomainChecker';
import About from './components/About';
import Clients from './components/Clients';
import Partners from './components/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import AboutPage from './pages/AboutPage';
import './index.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Check URL hash to determine page
    const hash = window.location.hash;
    if (hash === '#/about') {
      setCurrentPage('about');
      window.scrollTo(0, 0);
    } else if (hash === '#about' || hash === '') {
      setCurrentPage('home');
    }

    const handleHashChange = () => {
      const newHash = window.location.hash;
      if (newHash === '#/about') {
        setCurrentPage('about');
        window.scrollTo(0, 0);
      } else {
        setCurrentPage('home');
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (currentPage === 'about') {
    return (
      <>
        <Navbar />
        <AboutPage setCurrentPage={setCurrentPage} />
        <Footer />
        <WhatsAppButton />
      </>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <Navbar />
      <Hero />
      <main style={{ background: 'var(--off-white)' }}>
        <Services />
        <DomainChecker />
        <About setCurrentPage={setCurrentPage} />
        <Partners />
        <Clients />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
